/* eslint-disable import/prefer-default-export */
import { get } from 'lodash';
import { enrich } from '../../helpers';

export function selectRelations(slice, id) {
  return get(slice, `relations.${id}`, enrich());
}
